<div class="form-group" (click)="focus()">
  <div class="form-field__control">
    <ng-content select="[label]"> </ng-content>
    <ng-content select="[input]"> </ng-content>
  </div>
</div>

<ng-content select="[help]"></ng-content>
